import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from "@material-ui/icons/ShoppingBasketTwoTone";

// Components
import PurchaseOrderPromoTable from "./PurchaseOrderPromoTable";
import PurchaseAddItem from "./PurchaseAddItem";
import PurchaseEditShipping from "./PurchaseEditShipping";
import LoadingModal from "../../components/Modal/LoadingModal";

//React Router (for getting parameters)
import { useParams, useHistory } from "react-router-dom";

//number format plugin
import numeral from "numeral";

//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import { NavLink } from "react-router-dom";

import MessageBox from "../../components/MessageBox/MessageBox";

//cookies
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";

//customize buttons default and disabled color
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Preloader from "../../components/Preloader/Preloader";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    marginTop: 30,
    borderBottom: "1px solid #59b259",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#4f537e",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#c1c3d8",
  },
  infoText: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#FF0000",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "rgba(89, 178, 89, 0.09)",
    padding: "1rem",
    border: "1.5px solid #59b259",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #59b259",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
  root: {
    "&$disabled": {
      color: "#f2f2f2",
    },
  },
  disabled: {},
});

const PurchaseOrderCYOPInformation = () => {
  const { supid, delivery_date, promo, freight } = useParams();
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [supplier, setSupplier] = useState(null);
  const [warehouse, setWarehouse] = useState(null);
  const classes = useStyles();

  const [items, setItems] = useState([]); //data to display in PO table
  const [supplierItem, setSupplierItem] = useState(null); //data to display in Add Item dropdown
  const [promoType, setPromoType] = useState([]);
  const [poTotal, setPoTotal] = useState(0);
  const [shipTotal, setShipTotal] = useState(0);
  const [notes, setNotes] = useState("");
  const [packageList, setPackageList] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [wholesalePoint, setWholesalePoint] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [items_list, loadItemsDropdown] = useState([]);
  const [currentSelectedPPP, setCurrentSelectedPPP] = useState(0);

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  //state for managing loading modal
  const [showModal, setShowModal] = useState(false);

  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [btnDisabledAdd, setBtnDisabledAdd] = useState(true);
  let history = useHistory();

  const onHandlePress = () => {
    setShowForm(!showForm);
  };

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);
  //

  const headers = {
    'Content-Type': 'multipart/form-data',
};
  const get_items = () => {
    const formData = new FormData();
    formData.append('form_data', "");
const apiUrl = process.env.REACT_APP_API_URL+'get_items';
axios.post(apiUrl, formData, {headers:headers}).then((res) => {
  loadItemsDropdown(res.data.items);
});
};
  const save_po = async () => {
    setBtnDisabled(true); // disable button to avoid multiple saves
    setShowModal(true); //show loading/please wait modal
    const formData = new FormData();
    formData.append("packages", JSON.stringify(items));
    formData.append("trandate", delivery_date);
    formData.append("jc_user_id_no", get_cookies("branchidno"));
    formData.append("curcode", get_cookies("curcode"));
    formData.append("jc_username", get_cookies("username"));
    formData.append("shippingfreight", freight);
    formData.append("promotype", promoType.packagetypename);
    formData.append("packagetotalamount", promoType.wholesale_price);
    formData.append("packages_selected", "YES");
    formData.append("pofrom", supid);

    await axios
      .post(process.env.REACT_APP_API_URL + "save_po", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Added new PO");
        setMsgType("success");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
          history.push("/purchases/purchases-order-promo");
        }, 2000);
      })
      .catch(function (error) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  const addItem = () => {
    //     let found = items.some((x) => x.id === selectedItem.id);
    //     if (found) {
    //if item is existing in itemArray, add the qty instead
    //       let newItems = items.map((it) => {
    //         if (selectedItem.id === selectedItem.description) {
    //           //add
    //           it.qty += item.qty;
    //         }
    //         return it;
    //       });
    //       setItems(newItems);
    //     } else {
    //add new unique item to array
    setItems([
      ...items,
      {
        id: selectedItem.id,
        item_id: selectedItem.index,
        item_name: selectedItem.description,
      },
    ]);
    //     }
  };

  const deleteItem = (item_id) => {
    //console.log(item_id);
    let itemArray = items.filter((item) => item.item_id !== item_id);
    setItems(itemArray);
  };

  // componentDidMount / document.ready ?
  useEffect(() => {
    data();
    get_items();
  }, []);
  useEffect(() => {
    getTotalProductPackagePoints();

  }, [promoType]);



  //update PO total when items update
  useEffect(() => {
    // let po_total = 0;
    // items.forEach(item => po_total += (item.price*item.qty))
    // setPoTotal(po_total);
    if (items.length > 0) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
    // // if(items.length > 0) {
    // // 	setBtnDisabled(false); // re-enable
    // // }else{
    // // 	setBtnDisabled(true); // re-enable
    // }
    if (selectedItem.length < 1) {
      setBtnDisabledAdd(true); // re-enable
    } else {
      setBtnDisabledAdd(false); // re-enable
    }
  }, [selectedItem, items]);

  const data = async () => {
    //get data for single supplier
    await axios
      .get(process.env.REACT_APP_API_URL + "get_single_wholesaleset", {
        params: {
          promo_id: promo, //supplier_id
        },
      })
      .then((res) => {
        setPromoType(res.data.data);
        axios
          .get(process.env.REACT_APP_API_URL + "get_product_package_list", {
            params: {
              promotypename: res.data.data.packagetypename,
              promotype: res.data.data.packagetype,
              jc_user_id_no: branchIdNo,
              //supplier_id
            },
          })
          .then((res) => {
            setPackageList(res.data.data);
          })
          .catch((error) => {
            console.log(error.message);
          });
      })
      .catch((error) => {
        console.log(error.message);
      });

    // await axios.get(process.env.REACT_APP_API_URL+'get_supplier_items_list', {
    // 	params:{
    // 		supplier_id: supid,  //supplier_id
    // 	}
    // }).then((supplier_item_result)=>{
    // 	setSupplierItem(supplier_item_result.data.data);
    // }).catch((error)=>{
    // //console.log(error.message);
    // });
  };
  const getTotalProductPackagePoints = async () => {
    //get data for single supplier
    await axios
      .get(process.env.REACT_APP_API_URL + "getTotalProductPackagePoints", {
        params: {
          accounttype: promoType.packagetype, //supplier_id
        },
      })
      .then((res) => {

        setWholesalePoint(res.data.data.salespoints_startup);

      })
      .catch((error) => {
        console.log(error.message);
      });

    // await axios.get(process.env.REACT_APP_API_URL+'get_supplier_items_list', {
    // 	params:{
    // 		supplier_id: supid,  //supplier_id
    // 	}
    // }).then((supplier_item_result)=>{
    // 	setSupplierItem(supplier_item_result.data.data);
    // }).catch((error)=>{
    // //console.log(error.message);
    // });
  };
  const dropDownItems = {
		options: items_list,
		getOptionLabel: (option) => option.itemname  + ' (' + option.productpoints + ')',
    };

  const selectPackage = {
    options: packageList,
    getOptionLabel: (option) => option.description,
  };

  const ColorButton = withStyles(() => ({
    root: {
      color: "#fff",
      backgroundColor: "#4caf50",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#4caf50",
      },
    },
  }))(Button);

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <LoyaltyTwoTone />
        </div>
        <NavLink to={"/purchases"}>
          <h4 style={{ color: "#1D1C1A" }}>Purchases</h4>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <NavLink to={"/purchases/purchases-order-promo"}>
          <h4 style={{ color: "#1D1C1A" }}>
            Purchase Order (Choose Your Own Package)
          </h4>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <h4>Purchase Order Information</h4>
      </div>
      {promoType ? (
        <div className="page-container">
          <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
          <Card className={classes.card}>
            <div className={classes.cardHeader}>
              <Grid
                container
                spacing={0}
                style={{ justifyContent: "flex-end" }}
              >
                <Grid item xs={12}>
                  <div className={classes.subTitle}>
                    Purchase Order (Choose Your Own Wholesale Set)
                  </div>
                </Grid>
              </Grid>
            </div>
            {showForm == false ? (
              <>
                {" "}
                <CardContent>
                  <div className={classes.infoText}>
                    Please confirm the details of this Package Purchase
                    Transaction.
                  </div>
                  <div className={classes.infoContainer}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4} className={classes.infoTitle}>
                        Purchase From:
                      </Grid>
                      <Grid item xs={12} sm={8} className={classes.infoContent}>
                        {supid || ""}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4} className={classes.infoTitle}>
                        Wholesale set:
                      </Grid>
                      <Grid item xs={12} sm={8} className={classes.infoContent}>
                        {"Choose Your Own Wholesaleset"}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4} className={classes.infoTitle}>
                        Wholesale Price
                      </Grid>
                      <Grid item xs={12} sm={8} className={classes.infoContent}>
                        {promoType.curcode || ""}{" "}
                        {numeral(promoType.wholesale_price).format("0,0.00") ||
                          ""}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4} className={classes.infoTitle}>
                        Wholesale Type
                      </Grid>
                      <Grid item xs={12} sm={8} className={classes.infoContent}>
                        {promoType.packagetype || ""}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4} className={classes.infoTitle}>
                        Freight:
                      </Grid>
                      <Grid item xs={12} sm={8} className={classes.infoContent}>
                        {freight == "nofreight"
                          ? numeral(0).format("0,0.00")
                          : numeral(freight).format("0,0.00")}
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4} className={classes.infoTitle}>
                        Amount To Pay:
                      </Grid>
                      <Grid item xs={12} sm={8} className={classes.infoContent}>
                        {freight == "nofreight"
                          ? numeral(
                              Number(promoType.wholesale_price) + 0
                            ).format("0,0.00")
                          : Number(promoType.wholesale_price) + Number(freight)}
                      </Grid>
                    </Grid>
                  </div>
                </CardContent>
              </>
            ) : (
              <>
                <CardContent>
                  <TextField
                    id="outlined-basic"
                    label="Product Package Points"
                    variant="outlined"
                    type="text"
                    className={classes.field}
                    value={wholesalePoint} //to avoid label overlapping bug
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                                        <Grid item xs={9}>
                                            <Autocomplete
                                                {...dropDownItems}
                                                autoComplete
                                                includeInputInList
                                                className={classes.autoComplete}
                                                name="itemname"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        margin="normal"
                                                        label="Packages"	
                                                        variant="outlined"
                                                        required="true"
                                                    />
                                                )}
                                                onChange={(event, newValue) => {
                                                    if (!newValue == "" || !newValue == null){
                                                        const newData = {...selectedItem};
                                                        newData['id']= JSON.stringify(newValue.id, null, ' ');
                                                        newData['itemname']= newValue.itemname;
                                                        newData['unit']= newValue.unit;
                                                        setCurrentSelectedPPP(newValue.productpoints);
                                                        setSelectedItem({ ...newData });
                                                    }
                                                }}
                                            />
                                        </Grid>
                  <TextField
                    id="outlined-basic"
                    label="Contact Number"
                    variant="outlined"
                    type="text"
                    className={classes.field}
                    // value={} //to avoid label overlapping bug
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <ColorButton
                    variant="contained"
                    disabled={btnDisabledAdd}
                    color="primary"
                    classes={{
                      root: classes.root,
                      disabled: classes.disabled,
                    }}
                    onClick={addItem}
                  >
                    add
                  </ColorButton>
                  <PurchaseOrderPromoTable
                    items={items}
                    setItems={setItems}
                    deleteItem={deleteItem}
                  />
                </CardContent>
              </>
            )}
          </Card>
          <div className={classes.buttonContainer}>
            {/* <Button variant="contained">Back</Button> */}
            <ColorButton
              // disabled={btnDisabled}
              variant="contained"
              color="primary"
              classes={{
                root: classes.root,
                disabled: classes.disabled,
              }}
              onClick={onHandlePress}
            >
              Save
            </ColorButton>
          </div>
        </div>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default PurchaseOrderCYOPInformation;
